module.exports = __webpack_public_path__ + "static/media/infosection2.7053431a.jpeg";